
angular.module('mtic.components.login')
.component('mticPostIamRegistration', {

  templateUrl: 'template.html',

  bindings: {
    roleType: '<',
    profile: '<'
  },

  controllerAs: 'user',

  controller(
    $scope,
    $log,
    language,
    EventManager,
    userAccount,
    MticAlertModalService,
    LOGIN_CONSTANTS,
    api,
    LocaleService
  ) {

    // this
    const user = this;

    // event manager
    const eventManager = new EventManager('mticFinalization', $scope);

    // model

    // todo: replace with translation manager
    var text = $scope.text = {
      WELCOME: `Welcome {{firstName}} {{lastName}}, please proceed to choose your school below.`,
      TITLE: 'Microsoft Login',
      INVALIDACCOUNT: `Invalid Account Type!`,
      SCHOOL: 'School',
      COUNTRY: 'Country',
      CONTINUE: 'Continue',
      IAMEMAIL: 'IAM Email'
    }

    var NOSCHOOL_GROUP_ID_LUXEMBOURG = 1916;

    $scope.language = language;
    $scope.logout = userAccount.logout;

    user.flags = {
      loading: true,
      error: null,
      reset: function() {
        user.flags.loading = true;
        user.flags.error = null;
      },
      done: function(error) {
        user.flags.loading = false;
        if(error) {
          user.flags.error = error;
        }

        if(user.isStudent){
          user.autoRegisterStudentLuxembourg();
        }
      }
    }

    user.selections = {
      selectSchool: function(school) {
        user.info.school = school;
        user.groupSelected = true;
      },
      selectModule: function(classroom){
        user.info.class = classroom;
        user.groupSelected = true;
      }
    }

    user.welcomeText = function() {
      var msg = text.WELCOME.replace('{{firstName}}',user.info.firstName)
      msg = msg.replace('{{lastName}}', user.info.lastName);
      return msg;
    }



    user.autoRegisterStudentLuxembourg = function() {
      api.getNoSchoolClasses(NOSCHOOL_GROUP_ID_LUXEMBOURG)
      .then(function (classes) {
        var groupIds = _.map(classes, function(t){ return t.id });
        return api.signUpStudentThroughNoSchoolAll({
          group_ids: groupIds,
          user_name: user.info.iamUser,
          password: user.info.iam,
          first_name: user.info.firstName,
          last_name: user.info.lastName,
          email: user.info.iamUser,
          auth_type: 'microsoftStrategy',
          class_data: user.info.class_data
        })
      })
      .then(function() {
        LocaleService.setCurrentLocale('LUXEMBOURG');
        api.login({
          uuid: user.info.iamUser,
          password: user.info.iam,
          auth_type: 'microsoftStrategy'
        })
      });
    }

    user.register = function() {
      if(LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER === user.roleType || LOGIN_CONSTANTS.ACCOUNT_TYPES.VRETTA === user.roleType) {
        return api.signUpTeacherThroughGroup({
          group_id: user.info.school.id,
          user_name: user.info.iamUser,
          password: user.info.iam,
          first_name: user.info.firstName,
          last_name: user.info.lastName,
          email: user.info.iamUser,
          auth_type: 'microsoftStrategy',
          class_data: user.info.class_data
        }).
        then( function(){
          LocaleService.setCurrentLocale('LUXEMBOURG');
          api.login({
            uuid: user.info.iamUser,
            password: user.info.iam,
            auth_type: 'microsoftStrategy'
          })
        })
      }
      else if(LOGIN_CONSTANTS.ACCOUNT_TYPES.STUDENT === user.roleType) {
        $log.error('Student path has been divereted from this logic')
      }
      else{
        MticAlertModalService.set(text.INVALIDACCOUNT, {
          title: text.TITLE,
          callback(){
            userAccount.logout()
          }
        })
      }
    }

    var setInfo = function() {

      var msfUser = user.profile;

      user.info = {
        firstName: msfUser.first_name || msfUser.name.split(' ').slice(1).join(' '),
        lastName: msfUser.last_name || msfUser.name.split(' ')[0],
        iam: msfUser.oid,
        iamUser: msfUser.unique_name,
        class_data: msfUser.class_data
      }


      $log.log('msfUser : ', msfUser, user.info)

      user.isTesting = user.roleType === LOGIN_CONSTANTS.ACCOUNT_TYPES.VRETTA;

      user.isStudent = LOGIN_CONSTANTS.ACCOUNT_TYPES.STUDENT === user.roleType;

      user.isTeacher = LOGIN_CONSTANTS.ACCOUNT_TYPES.TEACHER === user.roleType;

    }



    user.$onInit = function() {

      user.flags.reset();

      setInfo();

      api.getCountries(user.isStudent)
      .then( function(countries) {
        user.countries = countries;
        user.flags.done();
      })
      .catch(function(err) {
        $log.error(err);
        user.flags.done(err.message);
      })

    }

    this.$onChanges = function() {
      setInfo();
    }

  }

});
